<template>
   <div>
        <div class="table-wrapper on-991" v-if="$i18n.locale=='en'">
            <div class="custom-table balance-table ">
                <div class="trow dark-gray">
                    <div data-width='30%' class=""></div>
                    <div class="bold white center">KD ’000</div>
                </div>
                <div class="trow lGray">
                    <div data-width='55%'></div>
                    <div data-width='15%' class='white font b-right'>Land and
                        <br /> building</div>
                    <div data-width='15%' class="white font b-right">Cellular and other
                        <br />equipment</div>
                    <div data-width='15%' class="white font end">Total</div>
                </div>
                <div class="trow b-top ">
                    <div data-width='55%' class='font'>Balance as of 1 January 2019</div>
                    <div data-width='15%' class='font'> 168,659</div>
                    <div data-width='15%' class="font">12,393</div>
                    <div data-width='15%' class="font end">181,052</div>
                </div>
                <div class="trow ">
                    <div data-width='55%' class='font'>Add: Additions</div>
                    <div data-width='15%' class='font'> 47,419</div>
                    <div data-width='15%' class="font"> -</div>
                    <div data-width='15%' class="font end"> 47,419</div>
                </div>
                <div class="trow ">
                    <div data-width='55%' class='font'>Less: Amortisation</div>
                    <div data-width='15%' class='font'> (45,303)</div>
                    <div data-width='15%' class="font"> (5,332)</div>
                    <div data-width='15%' class="font end"> (50,635)</div>
                </div>
                <div class="trow ">
                    <div data-width='55%' class='font'>Less: Retirement</div>
                    <div data-width='15%' class='font'>(7,327)</div>
                    <div data-width='15%' class="font">(1,266)</div>
                    <div data-width='15%' class="font end">(8,593)</div>
                </div>
                <div class="trow ">
                    <div data-width='55%' class='font'>Exchange adjustments</div>
                    <div data-width='15%' class='font'>(25)</div>
                    <div data-width='15%' class="font">74</div>
                    <div data-width='15%' class="font end">49</div>
                </div>
                <div class="trow ">
                    <div data-width='55%' class='font'>Closing balance as at 31 December 2019 (excluding assets of
                        <br />disposal group classified as held for sale)</div>
                    <div data-width='15%' class='font'>163,423</div>
                    <div data-width='15%' class="font">5,869</div>
                    <div data-width='15%' class="font end">169,292</div>
                </div>
            </div>
        </div>

        <!-- Arabic -->

        <div class="table-wrapper on-991" v-if="$i18n.locale=='ar'">
            <div class="custom-table balance-table ">
                <div class="trow dark-gray">
                    <div data-width='30%' class=""></div>
                    <div class="bold white center">ألف دينار كويتي</div>
                </div>
                <div class="trow lGray">
                    <div data-width='55%'></div>
                    <div data-width='15%' class='white font b-right'>أرض
                        <br />ومبنى</div>
                    <div data-width='15%' class="white font b-right">أجهزة هاتف 
                        <br />خلوي وأخرى</div>
                    <div data-width='15%' class="white font end">المجموع</div>
                </div>
                <div class="trow b-top ">
                    <div data-width='55%' class='font'>الرصيد كما في 1 يناير 2020</div>
                    <div data-width='15%' class='font'> 168,659</div>
                    <div data-width='15%' class="font">12,393</div>
                    <div data-width='15%' class="font end">181,052</div>
                </div>
                <div class="trow ">
                    <div data-width='55%' class='font'>يضاف: إضافات</div>
                    <div data-width='15%' class='font'> 47,419</div>
                    <div data-width='15%' class="font"> -</div>
                    <div data-width='15%' class="font end"> 47,419</div>
                </div>
                <div class="trow ">
                    <div data-width='55%' class='font'>ناقصًا: إطفاءات</div>
                    <div data-width='15%' class='font'> (45,303)</div>
                    <div data-width='15%' class="font"> (5,332)</div>
                    <div data-width='15%' class="font end"> (50,635)</div>
                </div>
                <div class="trow ">
                    <div data-width='55%' class='font'>ناقصًا: الاستبعاد</div>
                    <div data-width='15%' class='font'>(7,327)</div>
                    <div data-width='15%' class="font">(1,266)</div>
                    <div data-width='15%' class="font end">(8,593)</div>
                </div>
                <div class="trow ">
                    <div data-width='55%' class='font'>تعديلات صرف عملات أجنبية</div>
                    <div data-width='15%' class='font'>(25)</div>
                    <div data-width='15%' class="font">74</div>
                    <div data-width='15%' class="font end">49</div>
                </div>
                <div class="trow ">
                    <div data-width='55%' class='font'>الرصيد الختامي كما في 31 ديسمبر 2020 (باستثناء موجودات مجموعة 
                        <br />الاستبعاد المصنفة كمحتفظ بها لغرض البيع)</div>
                    <div data-width='15%' class='font'>163,423</div>
                    <div data-width='15%' class="font">5,869</div>
                    <div data-width='15%' class="font end">169,292</div>
                </div>
            </div>
        </div>
   </div>
</template>

<script>
export default {

}
</script>

<style>

</style>